import {InfoCircleOutlined} from '@ant-design/icons';
import {Tooltip, TooltipProps} from 'antd';
import React from 'react';

const InfoTooltip: React.FC<TooltipProps & {message?: string}> = ({
  message = '',
  ...props
}) => {
  return (
    <Tooltip title={message} {...props}>
      <InfoCircleOutlined className="infoIcon" />
    </Tooltip>
  );
};

export default InfoTooltip;
